/*
 * Copyright (c) 2012, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: 
 * class: HxOverrides
 * root Object
 * @constructor
 */
window.HxOverrides = function() {};
$hxClasses['HxOverrides'] = HxOverrides;
/** @private @type {Array} */
HxOverrides.__name__ = ["HxOverrides"];

/**
 * dateStr
 *
 * $type TFun([{ name => date, t => TInst(Date,[]), opt => false }],TInst(String,[]))
 * @private
 * @static
 * @param {Date}  date 
 * @return {string}
 */
HxOverrides.dateStr = function(date) {
	/** @type {number} */ 
	var m = date.getMonth() + 1;
	/** @type {number} */ 
	var d = date.getDate();
	/** @type {number} */ 
	var h = date.getHours();
	/** @type {number} */ 
	var mi = date.getMinutes();
	/** @type {number} */ 
	var s = date.getSeconds();
	return date.getFullYear() + "-" + (m < 10?"0" + m:"" + m) + "-" + (d < 10?"0" + d:"" + d) + " " + (h < 10?"0" + h:"" + h) + ":" + (mi < 10?"0" + mi:"" + mi) + ":" + (s < 10?"0" + s:"" + s);
};


/**
 * strDate
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(Date,[]))
 * @private
 * @static
 * @param {string}  s 
 * @return {Date}
 */
HxOverrides.strDate = function(s) {
	/** @type {Array} */
	var k;
	switch(s.length) {
		case 8:
			k = s.split(":");
			/** @type {Date} */ 
			var d = new Date();
			d["setTime"](0);
			d["setUTCHours"](k[0]);
			d["setUTCMinutes"](k[1]);
			d["setUTCSeconds"](k[2]);
			return d;
		case 10:
			k = s.split("-");
			return new Date(k[0],k[1] - 1,k[2],0,0,0);
		case 19:
			k = s.split(" ");
			/** @type {Array} */ 
			var y = k[0].split("-");
			/** @type {Array} */ 
			var t = k[1].split(":");
			return new Date(y[0],y[1] - 1,y[2],t[0],t[1],t[2]);
		default:
			throw "Invalid date format : " + s;
	}
};


/**
 * cca
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => index, t => TInst(Int,[]), opt => false }],TType(Null,[TInst(Int,[])]))
 * @private
 * @static
 * @param {string}  s 
 * @param {number}  index 
 * @return {number|undefined}
 */
HxOverrides.cca = function(s,index) {
	/** @type {Number} */
	var x = s.charCodeAt(index);
	if (x != x) {
		return undefined;
	}
	/*  isNaN will still return true*/
	/*  fast isNaN*/
	return x;
};


/**
 * substr
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => pos, t => TInst(Int,[]), opt => false },{ name => len, t => TInst(Int,[]), opt => true }],TInst(String,[]))
 * @private
 * @static
 * @param {string}  s 
 * @param {number}  pos 
 * @param {number}  len 
 * @return {string}
 */
HxOverrides.substr = function(s,pos,len) {
	if(pos != null && pos != 0 && len != null && len < 0) return "";
	if(len == null) len = s.length;
	if(pos < 0) {
		pos = s.length + pos;
		if(pos < 0) pos = 0;
	} else if(len < 0) len = s.length + len - pos;
	
	return s.substr(pos,len);
};


/**
 * remove
 *
 * $type TFun([{ name => a, t => TInst(Array,[TInst(remove.T,[])]), opt => false },{ name => obj, t => TInst(remove.T,[]), opt => false }],TEnum(Bool,[]))
 * @private
 * @static
 * @param {Array}  a 
 * @param {remove.T}  obj 
 * @return {boolean}
 */
HxOverrides.remove = function(a,obj) {
	var /** @type {number} */ i = 0;
	var /** @type {number} */ l = a.length;
	while(i < l) {
		if(a[i] == obj) {
			a.splice(i,1);
			return true;
		}
		i++;
	}
	return false;
};


/**
 * iter
 *
 * $type TFun([{ name => a, t => TInst(Array,[TInst(iter.T,[])]), opt => false }],TType(Iterator,[TInst(iter.T,[])]))
 * @private
 * @static
 * @param {Array}  a 
 * @return {Object}
 */

HxOverrides.iter = function (a) {
	var cur = 0;
	return {
		cur: cur, arr: a, hasNext: function () {
			return cur < a.length;
		}, next: function () {
			return a[cur++];
		}
	};
};

/** @type {HxOverrides} */
HxOverrides.prototype.__class__ = HxOverrides;
